import Image from 'components/Common/Image'
import NestableClickable from 'components/Common/NestableClickable'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import { useContext } from 'react'
import * as React from 'react'
import styled from 'styled-components'
import ModalContext from 'contexts/ModalContext'
import LOUNGE_AIRPORT_LOOKUP from './loungeData/loungeAirportLookup'
import LoungePassInfoModal from './LoungePassInfoModal'

const TileWrapper = styled(NestableClickable)`
  display: flex;
  flex-direction: row;
  gap: ${rem(12)};
  align-items: center;

  ${mediaQueryUp.tablet} {
    flex-direction: column;
    align-items: stretch;
  }
`

const ImageContainer = styled.div`
  width: ${rem(100)};
  height: ${rem(100)};
  border-radius: ${props => props.theme.borderRadius.L};
  overflow: hidden;
  position: relative;
  flex-shrink: 0;

  ${mediaQueryUp.tablet} {
    width: 100%;
    height: ${rem(180)};
  }
`

interface Props {
  experience: App.ExperienceOffer
}

function LoungePassesExperienceTile({ experience }: Props) {
  const showModal = useContext(ModalContext)
  const image = experience.images[0]
  const airportLookup = LOUNGE_AIRPORT_LOOKUP[experience.id]
  const airportName = airportLookup?.name ?? experience.location.city ?? experience.location.name
  const country = airportLookup?.country

  return <TileWrapper onClick={() => showModal(<LoungePassInfoModal experience={experience} />)}>
    <ImageContainer>
      <Image
        image={image}
        id={image ? undefined : 'lounge-pass-fallback-0b447d2c9fc5'}
        alt={experience.name}
        fit="center"
        dpr={2}
      />
    </ImageContainer>
    <Group direction="vertical" gap={0}>
      <BodyText variant="large" weight="bold">
        {airportName}
      </BodyText>
      <BodyText variant="medium">
        {experience.name}
      </BodyText>
      {country && <BodyText variant="small" colour="light-foreground-alt">
        {country}
      </BodyText>}
    </Group>
  </TileWrapper>
}

export { LoungePassesExperienceTile }
export default LoungePassesExperienceTile
